import React from 'react';
import { IconButton } from '@mui/material';
import { CloseIcon } from '../../Icons/Icons';
import './InstructionOverlay.scss';

interface InstructionOverlayProps {
    onClose: () => void;
    children: React.ReactNode;
}

const InstructionOverlay = ({ onClose, children }: InstructionOverlayProps) => {
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="instruction-overlay">
            <div className="overlay-backdrop" onClick={handleOverlayClick}></div>
            <div className="overlay-content">
                <div className="overlay-header">
                    <h2>Instructions</h2>
                    <IconButton className="close-button" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="overlay-body">{children}</div>
            </div>
        </div>
    );
};

export default InstructionOverlay;